// Formats a message list as a plain-text transcript, shared by the customer
// chat panel's copy/download controls and the admin console's copy button
// (ChatInteract.js) so both produce the same layout. Intermediate tool-call
// rounds (role: 'assistant', toolCalls set, no content — chat_bot.md §3.4's
// "looking that up…" state) are skipped since they have nothing to show a reader.
const SPEAKER_LABEL = { user: 'You', assistant: 'Assistant' };

export const formatChatTranscript = (messages, getLabel = (m) => SPEAKER_LABEL[m.role], title) => {
  const lines = messages
    .filter((m) => getLabel(m) && m.content)
    .map((m) => {
      const time = m.createdAt ? new Date(m.createdAt).toLocaleString() : '';
      return `${getLabel(m)}${time ? ` (${time})` : ''}:\n${m.content}`;
    });

  const header = ['Sustainably Sprouted — chat transcript'];
  if (title) header.push(title);
  return [...header, '', ...lines].join('\n\n');
};
